import { useSelectUserContext } from '@innovyze/stylovyze/lib/selectors';
import { LAST_TERMS_AND_CONDITIONS_VERSION } from '@innovyze/stylovyze/lib/types';
export default function useTermsAndConditionsAccepted() {
    const { termsAndConditions, id } = useSelectUserContext();
    const currentTermsAndConditions = termsAndConditions?.[LAST_TERMS_AND_CONDITIONS_VERSION];
    return { currentTermsAndConditions, initialized: !!id };
}
